import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { UnlinkedDevice } from "@/api/devices";
import { useAppSelector } from "@/hooks/useAppSelector";

interface ICreateDeviceForm {
  id: string;
  name: string;
  location: number;
  floor: number;
}

const createDeviceFields: InputField[] = [
  {
    label: "ID Устройства",
    name: "id",
    placeholder: "a1b2c3d4e5f6789012345678901234ef",
    type: "text",
    isRequired: true,
  },
  {
    label: "Название",
    name: "name",
    placeholder: "Dispenser Floor 1",
    type: "text",
    isRequired: true,
  },
  {
    label: "Локация",
    name: "location",
    placeholder: "1",
    type: "location",
    isRequired: true,
  },
  {
    label: "Этаж",
    name: "floor",
    placeholder: "1",
    type: "text",
    isRequired: true,
  },
];

export function CreateDeviceModal({
  disclosure,
  device,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  device: UnlinkedDevice | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);
  const businessProfileId = useAppSelector(
    (state) => state.businessProfile.businessProfile.id,
  );

  const handleError = useErrorHandling();

  const onSubmit = (data: ICreateDeviceForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.devices
        .create({
          device_id: data.id,
          name: data.name,
          location_id: data.location,
          owner_id: businessProfileId,
          floor: data.floor,
        })
        .then((_data) => {
          toast.success("Устройство успешно добавлено");
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Добавление устройства"
      modalErrors={modalErrors}
      fields={createDeviceFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
      defaultValues={{
        id: device?.id,
        name: device?.name,
      }}
    />
  );
}
